var _g, _ellipse, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDottedEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      left: 1,
      top: 1,
      width: 32,
      height: 30,
      display: "block",
      position: "relative",
      overflow: "hidden"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)",
    style: {
      visibility: "visible"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 15,
    rx: 7,
    ry: 14,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 1.3,
    strokeDasharray: "1.59 1.59",
    pointerEvents: "all"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedEllipse);
export default __webpack_public_path__ + "static/media/dotted-ellipse.3a692f79f9a1707ba5f09a7ea23c7b6e.svg";
export { ForwardRef as ReactComponent };